const TabNavigation = ({ tabs, changeTab, tabSelected }) => {
  return (
    <div className="simulationNavigationWrapper">
      {tabs.map((button, index) => (
        <button
          className={`simulationNavigationButton ${
            tabSelected === index ? "simulationNavigationButtonSelected" : ""
          }`}
          onClick={() => changeTab(index)}
          key={`simulationNavigationButton${index}`}
        >
          {index + 1}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
